export const getDashboardIRDOrders = `
query MyQuery($hotelId: String!, $lang: String) {
  getOrdersDetails(input: {hotelId: $hotelId, lang: $lang}) {
    completedTime
    createdAt
    delayReason
    deliveryLocation
    guestName
    hotelId
    id
    createdBy
    noOfItems
    additionalNote
    noOfGuests
    items {
    addOns {
    name
    price
    code
    }
    amount
    code
    cookingInstructions
    count
    name
    customisations {
    code
    name
    }
    }
    paymentMethod
    pk
    roomNo
    sk
    startTime
    status
    totalAmount
    updatedAt
    updatedBy
    version
  }
}`;

export const getDashboardSpaOrders = `
query MyQuery($hotelId: String!, $lang: String) {
  getSpaOrdersDetails(input: {hotelId: $hotelId, lang: $lang}) {
    bookingTime
    createdAt
    createdBy
    guestName
    guestType
    roomNo
    hotelId
    id
    spaId
    items {
      amount
      description
      name
      specialRequest
      treatmentDuration
    }
    numberOfGuest
    pax
    pk
    scheduledDate
    sk
    scheduledTime
    status
    totalAmount
    treatmentDuration
    updatedAt
    updatedBy
    version
  }
}`;

export const getRestaurantReservationDetails = `
query MyQuery($restaurantId: String!, $lang: String) {
  getRestaurantReservationDetails(input: {restaurantId: $restaurantId, lang: $lang}) {
    reservations {
      bookingDate
      date
      description
      exposure
      firstName
      guestType
      hotelId
      id
      isReservedForGuest
      lastName
      noOfGuests
      reserveFrom
      reserveUntil
      restaurantId
      roomNo
      status
      tableNumbers
    }
    tables {
      capacity
      duration
      exposure
      hotelId
      reservations
      restaurantId
      tableNumber
    }
  }
}
`;

export const getDashboardHouseKeepingOrders = `
query MyQuery($hotelId: String!, $lang:String) {
  getHouseKeepingOrdersDetails(input: {hotelId: $hotelId, lang:$lang}) {
    createdAt
    bookingTime
    bookingId
    createdBy
    guestName
    hotelId
    id
    items {
      id
      instructions
      name
      scheduledFor
    }
    pk
    requestType
    roomNo
    serviceName
    sk
    status
    updatedAt
    updatedBy
    version
  }
}`;

export const getDashboardOccupancyOrders = `
query MyQuery($hotelId: String! ) {
  getHouseStatus(input: {hotelId: $hotelId}) {
    activityStatus {
      arrivalsActualPersons
      arrivalsActualRoom
      arrivalsActualVIP
      arrivalsExpectedPersons
      arrivalsExpectedRoom
      arrivalsExpectedVIP
      dayUseRoomsPersons
      dayUseRoomsRoom
      dayUseRoomsVIP
      dayofArrivalCancelsPersons
      dayofArrivalCancelsRoom
      dayofArrivalCancelsVIP
      departuresActualPersons
      departuresActualRoom
      departuresActualVIP
      departuresExpectedPersons
      departuresExpectedRoom
      departuresExpectedVIP
      earlyDeparturesRoom
      earlyDeparturesPersons
      earlyDeparturesVIP
      extendedStaysRoom
      extendedStaysPersons
      extendedStaysVIP
      stayoversPersons
      stayoversRoom
      stayoversVIP
      walkInsPersons
    }
    complimentaryStatus {
      complimentaryArrivalsPersons
      complimentaryArrivalsRoom
      complimentaryDeparturesPersons
      complimentaryArrivalsVIP
      complimentaryDeparturesRoom
      complimentaryDeparturesVIP
      complimentaryStayOversPersons
      complimentaryStayOversRoom
      complimentaryStayOversVIP
    }
    endOfDayProjectionStatus {
      blocksnotPickedUp
      groupsandBlocksPersons
      groupsandBlocksVIP
      groupsandBlocksRoom
      individualsPersons
      individualsRoom
      individualsVIP
      maxOccupiedTonightPersons
      maxOccupiedTonightRoom
      maxOccupiedTonightVIP
      maxPertOccupiedTonight
      minAvailableTonight
      roomRevenue
      roomRevenueAvg
    }
    houseRoomStatus {
      cleanRoomOccupied
      cleanRoomVacant
      dirtyRoomOccupied
      dirtyRoomVacant
      inspectedRoomOccupied
      inspectedRoomVacant
      outofOrderRoomOccupied
      outofOrderRoomVacant
      outofServiceRoomOccupied
      outofServiceRoomVacant
      pickupRoomOccupied
      pickupRoomVacant
      queueRoom
    }
    roomSummaryStatus {
      outofOrder
      totalPhysicalRooms
      outofService
    }
    turnDownStatus {
      turnDownCompleted
      turnDownNotRequired
      turnDownRequired
    }
    useStatus {
      houseUseArrivalsPersons
      houseUseArrivalsRoom
      houseUseArrivalsVIP
      houseUseDeparturesPersons
      houseUseDeparturesRoom
      houseUseDeparturesVIP
      houseUseStayoversPersons
      houseUseStayoversRoom
      houseUseStayoversVIP
    }
  }
}`;

export const getDashboardOccupancyCheckin = `
query MyQuery($hotelId: String!) {
  getTotalCheckIn(input: {hotelID: $hotelId }) {
    digitalKeysActivated
    selfCheckIns
  }
}`;

export const getDashboardOccupancyBooking = `
query MyQuery($hotelId: String!,$date: String!) {
  getFutureBookingDashboard(input: {endDate: $date, hotelId: $hotelId, startDate:$date}){
    checkInCompleted
    checkInPending
    checkInTotal
    checkOutCompleted
    checkOutPending
    checkOutTotal
    arrivalList {
      confirmationId
      confirmationType
      details {
        checkOutDate
        checkInDate
        contactPerson {
          email
          firstName
          id
          emailOperaId
          lastName
          phoneNumber
          phoneOperaId
          title
        }
        hotel_name
        hotelId
      }
      
    }
  }  
}`;

export const getDashboardFnBOrders = `
query MyQuery($hotelId: String!,$restaurantId: String!, $lang : String) {
  getFAndBOrderDetails(input: {
    hotelId: $hotelId, 
    restaurantId:$restaurantId, 
    lang : $lang
  }){
    orders {
      status
      completedTime
      createdAt
      guestName
      guestType
      hotelId
      id
      items {
        addons {
          code
          name
          price
        }
        amount
        code
        cookingInstructions
        count
        customisations {
          code
          name
        }
        image
        name
      }
      lang
      noOfGuests
      noOfItems
      pk
      restaurantId
      sk
      startTime
      tableNumber
      additionalNote
      totalAmount
      paymentMethod
      roomNumber
      phoneNumber
    }
    bills {
      completedTime
      createdAt
      guestName
      guestType
      hotelId
      id
      lang
      noOfGuests
      noOfItems
      orders {
        id
        items {
          addons {
            code
            name
            price
          }
          amount
          code
          cookingInstructions
          count
          customisations {
            code
            name
          }
          image
          name
        }
      }
      pk
      restaurantId
      sk
      startTime
      status
      tableNumber
      tipAmount
      phoneNumber
      paymentMethod
    }
  }
}`;

export const getFutureBookingArrivalList = `
query MyQuery($hotelId: String!,$date: String!) {
  getFutureBookingDashboard(input: {endDate: $date, hotelId: $hotelId, startDate:$date, endDate : $date, toDate: $date}){
    arrivalList {
      confirmationId
      confirmationType
      details {
        checkOutDate
        checkInDate
        contactPerson {
          email
          firstName
          id
          emailOperaId
          lastName
          phoneNumber
          phoneOperaId
          title
        }
        hotel_name
        hotelId
      }
      
    }
  }  
}`;

export const getChatMsgStatus = `
query MyQuery($hotelId: String!, $reservationIds : [String]) {
  getChatMsgStatus(input: { hotelId: $hotelId , reservationIds : $reservationIds}){
    status {
      reservationId
      status
    }
  }  
}`;
